import React from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import { badgeCss } from '../../legacy-design-system/text'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Severity } from '../vulnerability-severity'
import { SinkGroupSeverity } from '../vulnerability-severity/sink-group-severity'

type AllSeverities = Severity | SinkGroupSeverity
interface Props {
  readonly severity: AllSeverities
  readonly e2eTestId?: string
}

const vulnerabilitySeverityBadgeCss = cx(
  badgeCss,
  css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 73px;
    height: 20px;
    border-radius: 2px;
  `
)

const cssMap: Record<AllSeverities['name'], string> = {
  CRITICAL: cx(
    vulnerabilitySeverityBadgeCss,
    css`
      background-color: ${theme.color.red50};
      color: ${theme.color.white};
    `
  ),
  HIGH: cx(
    vulnerabilitySeverityBadgeCss,
    css`
      background-color: ${theme.color.orange50};
      color: ${theme.color.white};
    `
  ),
  MEDIUM: cx(
    vulnerabilitySeverityBadgeCss,
    css`
      background-color: ${theme.color.yellow50};
      color: ${theme.color.white};
    `
  ),
  LOW: cx(
    vulnerabilitySeverityBadgeCss,
    css`
      background-color: ${theme.color.neutral40};
      color: ${theme.color.neutral100};
    `
  ),
  NOTE: cx(
    vulnerabilitySeverityBadgeCss,
    css`
      background-color: ${theme.color.neutral30};
      color: ${theme.color.neutral80};
    `
  ),
  MULTIPLE: cx(
    vulnerabilitySeverityBadgeCss,
    css`
      background-color: ${theme.color.neutral80};
      color: ${theme.color.white};
    `
  )
}

export function VulnerabilitySeverityBadge({
  severity,
  e2eTestId = 'vuln-severity-badge'
}: Props) {
  const translatedSeverity = useIntl().formatMessage({ id: severity.i18nID })

  return (
    <div className={cssMap[severity.name]} data-e2e={e2eTestId}>
      {translatedSeverity}
    </div>
  )
}
